export enum ReferralFormType {
  IFA = 'ifa',
  SjpIFA = 'sjp-ifa',
}
